<template>
  <div>
    <div class="login" @click="vkLogion"></div>
  </div>
</template>

<script>
// import { closeDialog } from '../../utils/Qtbridge'
export default {
  name: 'Vk',
  props: {
    account: String
  },
  data () {
    return {
      userInfo: {}
    }
  },
  created () {
    // window.VK.init({ apiId: '8092164' });
    window.VK.init({ apiId: '8106996' })
    // window.VK.init({ apiId: '6818613' }); // 正式 id
  },
  methods: {
    vkLogion () {
      const _this = this
      window.VK.Auth.login(function (response) {
        console.log(_this.account, response)
        if (response.session) {
          _this.userInfo = {
            id: response.session.user.id,
            name: `${response.session.user.last_name} ${response.session.user.first_name}`,
            token: response.session.sid,
            type: 'vk',
            expire: response.session.expire - parseInt((new Date().getUTCTime() || 0) / 1000)
          }
          _this.login()
        } else {
          // if (response.status === 'not_authorized') {
          //   setTimeout(() => {
          //     closeDialog()
          //   }, 300)
          // }
          _this.$msg.success(_this.$t('login_fail_2'))
        }
      })
    },
    login () {
      this.$emit('changePopup', {
        name: 'Result',
        params: {
          type: 'success',
          loginData: this.userInfo
        }
      })
    }
  }
}
</script>

<style lang='less' scoped >
.login {
  width: 31px;
  height: 31px;
  background: url(~@img/icon_vk.png) center center no-repeat;
  background-size: 100% 100%;
}
</style>
